import React from 'react';
import { Monitor, Apple, Smartphone, Globe2, Chrome } from 'lucide-react';
import { useLang } from '../context/LangContext';

const Platforms = () => {
  const { t } = useLang();
  const items = [
    { icon: Monitor, name: t.platforms.windows },
    { icon: Apple, name: t.platforms.mac },
    { icon: Smartphone, name: t.platforms.ios },
    { icon: Chrome, name: t.platforms.android },
    { icon: Globe2, name: t.platforms.web }
  ];
  return (
    <section className="py-16 md:py-20 bg-white border-y border-neutral-100">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="text-center mb-10">
          <h3 className="text-[26px] md:text-[36px] font-black tracking-[-0.02em] text-neutral-900">{t.platforms.title}</h3>
          <p className="mt-3 text-[15px] text-neutral-500">{t.platforms.subtitle}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {items.map((it, i) => {
            const Ic = it.icon;
            return (
              <button key={i} className="group flex items-center gap-3 px-5 h-14 rounded-full bg-neutral-50 hover:bg-neutral-900 border border-neutral-200 hover:border-neutral-900 transition-all">
                <Ic className="w-5 h-5 text-neutral-700 group-hover:text-white transition-colors" />
                <span className="text-[14px] font-semibold text-neutral-800 group-hover:text-white transition-colors">{it.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Platforms;
